import React, { useState, useEffect } from 'react';
import axios from 'axios';

const TeacherReport = ({ teacher, madrasaInfo }) => {

  const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };


  const openPrintView = (teacherData) => {
    const teacher = teacherData || teacher;
    const printContent = `
    <html>
      <head>
        <title>Staff Report - ${teacher.name}</title>
        <style>
          @page { margin: 20px; }
          body { font-family: Arial; margin: 20px; }
          .header { text-align: center; margin-bottom: 20px; }
          .logo { width: 100px; height: 100px; }
          .school-info { margin-bottom: 15px; }
          table { width: 100%; border-collapse: collapse; margin: 15px 0; }
          th { background-color: #2980b9; color: white; padding: 8px; }
          td { padding: 8px; border: 1px solid #ddd; }
          .section-title { font-size: 16px; margin: 20px 0 10px; }
          .sub-section { margin-left: 15px; margin-top: 10px; }
        </style>
      </head>
      <body>
        <div class="header">
          <img src="https://res.cloudinary.com/djg7v9dna/image/upload/v1739198257/Logo/kgamz0yjfr9uy8dsbnur.webp" 
               class="logo" alt="School Logo">
          <div class="school-info">
            <h2>${madrasaInfo.schoolName || 'Ummu Dhardha Ladies Islamic College'}</h2>
            <p>${madrasaInfo.schoolAddress || 'Meera Nagar, Beach Road, Akkaraipattu. EP. 32400. Sri Lanka.'}</p>
            <p>Tel: ${madrasaInfo.schoolPhoneNumber || '+94 67 205 3211'} | Email: ${madrasaInfo.schoolEmail || 'info@ummudhardha.lk'}</p>
          </div>
        </div>

        <h2>Staff Report: ${teacher.name}</h2>
        
        <div class="section">
          <h3 class="section-title">Personal Information</h3>
          <p>Staff ID: ${teacher.teacherID || 'N/A'}</p>
          <p>Name: ${teacher.name || 'N/A'}</p>
          <p>Email: ${teacher.email || 'N/A'}</p>
          <p>Type: ${teacher.type || 'N/A'}</p>
          <p>Salary: ${teacher.salary || 'N/A'}</p>
          <p>Salary Unit: ${teacher.salaryUnit || 'N/A'}</p>
          <p>Join Date: ${teacher.joinDate ? formatDate(teacher.joinDate) : 'N/A'}</p>
          <p>City: ${teacher.city || 'N/A'}</p>
          <p>Country: ${teacher.country || 'N/A'}</p>
          <p>State: ${teacher.state || 'N/A'}</p>
          <p>Years of Experience: ${teacher.yearOfExperince || 'N/A'}</p>
        </div>

        <div class="footer">
          Generated on: ${new Date().toLocaleDateString()}
        </div>
      </body>
    </html>
  `;

    const printWindow = window.open('', '_blank');
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.print();
  };

  return (
    <div>
      <button onClick={() => openPrintView(teacher)}>Print Teacher Report</button>
    </div>
  );
};

export default TeacherReport;
